import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import AppRoutes from './../components/routes'
import ToasterMessage from './ToasterMessage'
import HelpPage from './NavOptions/HelpPage'
import FindPeopleForm from './Search/FindPeopleForm'
import SearchSpotForm from './Search/SearchSpotForm'
import Checkout from './checkout'
import { updateIsBookingOpen } from './../actions'

class Root extends Component {

  componentDidMount() {

      var rnd = window.rnd || Math.floor(Math.random()*10e6);
      var pid456009 = window.pid456009 || rnd;
      var plc456009 = window.plc456009 || 0;
      var abkw = window.abkw || 'E43072E4-DE76-7EF3-2FD4D40658BC5DC7';
      var absrc = 'https://servedbyadbutler.com/adserve/;ID=164148;size=0x0;setID=456009;type=js;sw=' + screen.width + ';sh=' + screen.height + ';spr=' + window.devicePixelRatio + ';kw=' + abkw + ';pid=' + pid456009 + ';place=' + (plc456009++) + ';rnd=' + rnd + ';click=CLICK_MACRO_PLACEHOLDER';

      //document.write('<scr'+'ipt src="'+absrc+'" type="text/javascript" ></scr'+'ipt>');
  }

  constructor(props) {
    super(props)
    this.intervalRef = null
    this.updateBookingOpenFlag(props)
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.dtmOpen !== this.props.dtmOpen &&
      nextProps.dtmClose !== this.props.dtmClose
    ) {
      this.intervalRef && clearInterval(this.intervalRef)
      this.intervalRef = null
      this.updateBookingOpenFlag(nextProps)
    }
  }

  updateBookingOpenFlag({ dtmOpen, dtmClose }) {
    if (!this.intervalRef && dtmOpen && dtmClose) {
      this.props.dispatch(updateIsBookingOpen(dtmOpen, dtmClose))
      this.intervalRef = setInterval(() => {
        this.props.dispatch(updateIsBookingOpen(dtmOpen, dtmClose))
      }, 20000) // udating booking flag after one sec
    }
  }

  getSectionClassName() {
    const {
      isDrawerOpened,
      spotInfoDetailedView,
      isNavHelpOpened,
      isSearchFormOpened,
      isFindPeopleFormOpened,
      isCheckoutPageOpened,
    } = this.props

    let className = 'map'
    if (isDrawerOpened) {
      className += ' drawer-opened'
    }
    if (spotInfoDetailedView) {
      className += ' backdrop'
    }
    if (isNavHelpOpened || isSearchFormOpened || isCheckoutPageOpened) {
      className += ' fullscreen'
    }
    if (isFindPeopleFormOpened) {
      className += ' fullscreen fullscreen-alt'
    }

    return className
  }

  render() {
    const { toasters } = this.props
    const className = this.getSectionClassName()
    return (
      <div>
        <section className={className}>
          <div className="toaster-messages">
            {toasters.map((toaster, index) => (
              <ToasterMessage key={index} {...toaster} />
            ))}
          </div>
          <AppRoutes />
        </section>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { dtmOpen, dtmClose } = state.mapAccommodationInfo
  const {
    isDrawerOpened,
    spotInfoDetailedView,
    isNavHelpOpened,
    isSearchFormOpened,
    isFindPeopleFormOpened,
    isCheckoutPageOpened,
  } = state.navOptions
  const { toasters } = state.session
  return {
    dtmOpen,
    dtmClose,
    isDrawerOpened,
    spotInfoDetailedView,
    isNavHelpOpened,
    isSearchFormOpened,
    isFindPeopleFormOpened,
    isCheckoutPageOpened,
    toasters,
  }
}

export default connect(mapStateToProps)(Root)



// WEBPACK FOOTER //
// ./src/containers/root.js